import { Accordion, AccordionSummary, AccordionDetails } from "@mui/material";
import { AlertLabel } from "./alertItemHeader/AlertsPanelHeader.style";
import ExpandMoreIcon from "@mui/icons-material/ExpandMore";

function ReadAlertsWidget({
  children,
  title,
}: {
  children: React.ReactNode;
  title: string;
}) {
  return (
    <Accordion
      sx={{ mb: 1, maxHeight: "50%", backgroundColor: "background.paper" }}
      elevation={2}
    >
      <AccordionSummary
        expandIcon={<ExpandMoreIcon />}
        aria-controls="read-alerts-content"
        id="read-alerts-header"
        sx={{
          maxHeight: "75%",
        }}
      >
        <AlertLabel data-testid="alert-label" variant="subtitle1">
          {title}
        </AlertLabel>
      </AccordionSummary>
      <AccordionDetails
        sx={{
          p: 0,
          backgroundColor: "white",
          maxHeight: "327px",
          overflow: "auto",
        }}
      >
        {children}
      </AccordionDetails>
    </Accordion>
  );
}

export default ReadAlertsWidget;
